import { IContatos } from "../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import {
    IEnviarMensagem,
    ITransferirMensagem,
} from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import {
    DesvincularTelefoneContatoService,
    EnviarMensagemService,
    FinalizarAtendimentoService,
    ListarTelefoneContatoService,
    TransferirAtendimentoService,
    VincularContatoService,
} from "../../../Services/HelpDesk/Atendimento/AtendimentoServices";
import { ValidationErr } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

export function EnviarMensagemController(mensagem: IEnviarMensagem) {
    return Controller(EnviarMensagemService(mensagem));
}

export function TransferirAtendimentoController(
    IdEquipeTransferencia: number,
    IDUsuarioTransferencia: number,
    transferencia: ITransferirMensagem
) {
    return Controller(
        TransferirAtendimentoService(
            IdEquipeTransferencia,
            IDUsuarioTransferencia,
            transferencia
        )
    );
}

export function VincularContatoController(tel: string, contato: IContatos) {
    return Controller(VincularContatoService(tel, contato));
}

export function FinalizarAtendimentoController(numeroCliente: string) {
    return Controller(FinalizarAtendimentoService(numeroCliente));
}

export async function ListarTelefoneContatoController(cpfOuEmail: string) {
    const Response = await ListarTelefoneContatoService(cpfOuEmail)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                ValidationErr(err);
            } else
                toastr.error(
                    "Não foi possível se conectar com o servidor, cheque a sua conexão com a internet",
                    "Erro de Conexão"
                );

            throw err;
        });
    return Response;
}

export async function DesvincularTelefoneContatoController(
    telefone: string,
    idContato: number,
    idContatoTelefone: number
) {
    const Response = await DesvincularTelefoneContatoService(
        telefone,
        idContato,
        idContatoTelefone
    )
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                ValidationErr(err);
            } else
                toastr.error(
                    "Não foi possível se conectar com o servidor, cheque a sua conexão com a internet",
                    "Erro de Conexão"
                );

            throw err;
        });
    return Response;
}
